/**
 * Canal entre a tela de PRÉVIA do PMS e o cardápio embutido nela (`/menu/:slug?preview=1`).
 *
 * A prévia roda o cardápio real num iframe da MESMA origem e experimenta cores por `postMessage`
 * antes de salvar. O cardápio só aceita a mensagem em modo prévia e da própria origem — fora
 * disso, ela é ignorada.
 */
export const MENU_PREVIEW_QUERY_PARAM = 'preview';

export const MENU_PREVIEW_THEME_MESSAGE_TYPE = 'hmax-menu-preview-theme';

export type MenuPreviewThemeMessage = {
  type: typeof MENU_PREVIEW_THEME_MESSAGE_TYPE;
  backgroundColor: string;
  textColor: string;
};
